export class TrainingProgram {
    trainingProgramId: number;
    trainingProgramTypeName: string;
    trainingProgramTypeId: number;
    trainingProgramCode: string;
    programName: string;
    trainingProgramName1: string;
}

export const UnfoundProgramDefaultCode: string = 'Other';

export class TrainingProgramType {
    trainingProgramTypeId: number;
    isCombinedProgram: boolean;
}

export enum TrainingProgramTypes {
    Neurology = 101,
    ChildNeurologyAndNeurodevelopmentalDisabilities = 103,
    ChN = 104,
    ClinicalNeurophysiology = 105,
    VascularNeurology = 106,
    Psychiatry = 107,
    AddictionPsychiatry = 108,
    Cap = 110,
    ForensicPsychiatry = 111,
    GeriatricPsychiatry = 112,
    PsychosomaticMedicine = 113,
    SleepMedicine = 114,
    PsychiatryAndInternalMedicine = 115,
    PsychiatryAndFamilyMedicine = 116,
    TripleBoard = 117,
    PsychiatryNeurology = 119,
    NeuromuscularMedicine = 120,
    PainMedicine = 123,
    HospiceAndPalliativeMedicine = 124,
    Epilepsy = 162,
    PostPediatricPortal = 163,
    Other = 171
}